import React from 'react';
import cx from 'classnames';
import styles from './EngageSidebar.module.scss';
import { Icon } from '../Icon';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../Button/Button';

const SidebarChatWithUs = props => {
  const { mini, allowAnimation } = props;
  const { t } = useTranslation();

  const toggleChat = () => {
    if ($crisp && $crisp?.is) {
      if (!$crisp.is('chat:opened')) {
        $crisp.push(['do', 'chat:show']);
        $crisp.push(['do', 'chat:open']);
      } else {
        $crisp.push(['do', 'chat:hide']);
        $crisp.push(['do', 'chat:close']);
      }
    }
  };

  return (
    <CustomButton
      className={cx(styles.sidebarSection, { [styles.mini]: mini }, { [styles.animate]: allowAnimation })}
      variant="link"
      onClick={toggleChat}
      ariaLabel={mini && 'Chat with us'}
    >
      <Icon className={styles.sidebarIcon} src="chat_with_us" />
      {mini ? null : <span className={styles.name}>{t('sidebar.chat_with_us')}</span>}
    </CustomButton>
  );
};

export default SidebarChatWithUs;
